<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><b>Contents</b></p>
<p class="toc"><a href="#/html/9780292747500_05_ack">Acknowledgments</a></p>
<p class="toc1"><a href="#/html/9780292747500_07_int">Introduction: Tuning in to Palestine’s Radio History</a></p>
<p class="toc"><span href="#/html/9780292747500_08_ch1" title="Link target outside of Sample">1. Selling Radio, Selling Radios: Advertising Sets in Mandate Palestine</span></p>
<p class="toc"><span href="#/html/9780292747500_09_ch2" title="Link target outside of Sample">2. Peasants into Palestinians: Rural and School Broadcasting</span></p>
<p class="toc"><span href="#/html/9780292747500_10_ch3" title="Link target outside of Sample">3. Broadcasting a Nationalist Modernity: The PBS Arabic Section</span></p>
<p class="toc"><span href="#/html/9780292747500_11_ch4" title="Link target outside of Sample">4. Putting Religion on the Radio</span></p>
<p class="toc"><span href="#/html/9780292747500_12_ch5" title="Link target outside of Sample">5. Claiming the PBS: Whose National Radio?</span></p>
<p class="toc"><span href="#/html/9780292747500_13_conc" title="Link target outside of Sample">Conclusion: The Multiple Afterlives of the PBS</span></p>
<p class="toc1"><span href="#/html/9780292747500_14_tim" title="Link target outside of Sample">Timeline</span></p>
<p class="toc1"><span href="#/html/9780292747500_15_not" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/html/9780292747500_16_bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/html/9780292747500_17_idx" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292747500_04_toc.vue?22a70159